import { c as _c } from "react/compiler-runtime";
import { getOrgApiKeysOptions } from '@onefootprint/fetch-dashboard';
import { useIntl } from '@onefootprint/hooks';
import type { DashboardSecretApiKey } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import take from 'lodash/take';
export type GetApiKeysResponse = DashboardSecretApiKey[];
const useApiKeys = () => {
  const $ = _c(3);
  const {
    formatDateWithTime
  } = useIntl();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgApiKeysOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== formatDateWithTime) {
    t1 = {
      ...t0,
      select: response => take(response.data, 10).map(apiKey => ({
        ...apiKey,
        createdAt: formatDateWithTime(new Date(apiKey.createdAt)),
        lastUsedAt: apiKey.lastUsedAt ? formatDateWithTime(new Date(apiKey.lastUsedAt)) : undefined
      }))
    };
    $[1] = formatDateWithTime;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};
export default useApiKeys;